import React from "react";
interface LoadingSpinnerProps {
  reverse?: boolean;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ reverse = false }) => {
  return (
    <div className="d-flex justify-content-center align-items-center m-0 p-0">
      <div
        className={`spinner-border ${reverse ? 'text-white' : 'tm-text-primary'}`}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;